const useEllipsis = (text, length = 50, tail = '...') => {
	if (text.length <= length) return text;
	const displayText = text.slice(0, length - tail.length);
	return displayText + tail;
};

export default useEllipsis;
